import { createContext, useContext, type ReactNode } from 'react';

export type SupportSurface = 'standalone' | 'portal' | 'legacyPortal';

export interface SupportRoutes {
  list: string;
  newIssue: string;
  issue: (id: string) => string;
}

const routesBySurface: Record<SupportSurface, SupportRoutes> = {
  standalone: {
    list: '/',
    newIssue: '/yeni',
    issue: (id) => `/issue/${encodeURIComponent(id)}`,
  },
  portal: {
    list: '/support',
    newIssue: '/support/new',
    issue: (id) => `/support/issue/${encodeURIComponent(id)}`,
  },
  legacyPortal: {
    list: '/support',
    newIssue: '/support/new',
    issue: (id) => `/support/issue/${encodeURIComponent(id)}`,
  },
};

interface SupportSurfaceValue {
  surface: SupportSurface;
  isPortal: boolean;
  routes: SupportRoutes;
}

const SupportSurfaceContext = createContext<SupportSurfaceValue>({
  surface: 'standalone',
  isPortal: false,
  routes: routesBySurface.standalone,
});

export function SupportSurfaceProvider({
  surface,
  children,
}: {
  surface: SupportSurface;
  children: ReactNode;
}) {
  return (
    <SupportSurfaceContext.Provider
      value={{ surface, isPortal: surface === 'portal', routes: routesBySurface[surface] }}
    >
      {children}
    </SupportSurfaceContext.Provider>
  );
}

export function useSupportSurface() {
  return useContext(SupportSurfaceContext);
}
